import type { ObserverHolding } from "../worker/src/observer-holdings";

type ObserverView = {
  isAdmin: boolean;
  isSpectator?: boolean;
  isDisplay: boolean;
  players: Array<{ id: string; name: string }>;
  observerHoldings?: ObserverHolding[];
};

export function observerHoldingsHtml(room: ObserverView, escapeHtml: (value: string) => string) {
  if (!room.isAdmin || !room.isSpectator || room.isDisplay || !room.observerHoldings?.length) return "";
  return `<section class="observer-holdings" aria-labelledby="observer-holdings-title">
    <h2 id="observer-holdings-title">All players’ holdings</h2>
    <p>Visible while you sit out as room admin.</p>
    <div class="observer-holdings__grid">${room.observerHoldings.map((holding) => {
      const playerName = room.players.find((player) => player.id === holding.playerId)?.name;
      return `<article class="observer-holdings__player"><h3>${playerName ? `${escapeHtml(playerName)} · ` : ""}${escapeHtml(holding.label)}</h3>
        <ul class="observer-holdings__values">${holding.values.length ? holding.values.map((value) => {
          const die = holding.kind === "dice" && /^[1-6]$/.test(value) ? "⚀⚁⚂⚃⚄⚅"[Number(value) - 1] : null;
          return `<li class="observer-holdings__value observer-holdings__value--${holding.kind}"${die ? ` aria-label="Die ${value}"` : ""}>${die || escapeHtml(value)}</li>`;
        }).join("") : "<li class=\"observer-holdings__empty\">None</li>"}</ul></article>`;
    }).join("")}</div>
  </section>`;
}
